// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"127be8e2","455":"2e76a417","977":"95edf1fd"}[chunkId] + ".chunk.js";
};